import store from '../store';

export default {
    data() {
        return {
            addingToCart: false,
        };
    },

    computed: {
        postUrl() {
            return route('blog.show', this.post.slug);
        },

        hasBaseImage() {
            return this.post.base_image.length !== 0;
        },

        getCreatedDate() {
            var date = new Date(this.post.created_at);
            return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '.' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '.' + date.getFullYear();
        },

        baseImage() {
            if (this.hasBaseImage) {
                return this.post.base_image.path;
            }

            return `${window.FleetCart.baseUrl}/themes/storefront/public/images/image-placeholder.png`;
        },
    },

    methods: {

    },
};
